<template>
  <tr class="no_edit">
    <td :data-th="'Vytvořeno' | translate" class="first_data" v-html="$_date_formatFull(entity.timestamp_created)" />
    <td :data-th="'Data' | translate"><pre @click.stop="showModal" class="device-metadata-data">{{ entity.data | json | ellipsis }}</pre></td>
  </tr>
</template>

<script>
export default {
    name: "DeviceMetadataRow",
    props: {
        entity: Object,
    },
    filters: {
        json(value) {
            return JSON.stringify(value, null, 2)
        },
        ellipsis(value) {
          return value.length > 100
              ? value.substring(0, 100) + '...'
              : value
        }
    },
    methods: {
      showModal() {
        this.$emit('showModal', this.entity)
      }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/devices/detail/DeviceMetadataRow.vue